/*
  CC Video - behaviour for snippets/cc-video.liquid.

  tap     PDP gallery. Poster + play button; the <video> lives in a <template>
          until it is needed, so nothing downloads while it is off-screen.
          AUTOPLAYS muted + inline + looping once it is the most visible
          gallery video (60%+ on screen: on load if it's the first item, or
          when swiped/scrolled into view). Pauses below 25% visible. One plays
          at a time. A play/pause button (no native controls) lets the shopper
          stop it, and a video they paused stays paused until they play it.
          No autoplay with prefers-reduced-motion or Save-Data, or once the
          browser refuses it (iOS Low Power Mode): poster + play button, as
          before. YouTube/Vimeo stay tap-to-play (an iframe can't be paused
          when it scrolls away).

  SOUND   never, in either mode. lockMute() mutes every video and re-mutes it
          on any volumechange, whatever caused it.

  ambient Hero / banner. Muted autoplay loop. Sources carry data-src and are
          attached only when the video comes within 200px of the viewport, and
          only while its optional media query matches, so a desktop+mobile pair
          never downloads both. Pauses off-screen and in hidden tabs.
          Never autoplays with prefers-reduced-motion or Save-Data: the poster
          stays and the toggle offers Play. If the browser refuses autoplay
          (iOS Low Power Mode) the same thing happens.
*/
(function () {
  if (window.ccVideo) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saveData = !!(navigator.connection && navigator.connection.saveData);

  function attachSources(video) {
    var sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) return false;
    sources.forEach(function (s) {
      s.src = s.getAttribute('data-src');
      s.removeAttribute('data-src');
    });
    video.load();
    return true;
  }

  function safePlay(video, onFail) {
    video.muted = true;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () { if (onFail) onFail(); });
  }

  // Sound can never play: muted now, muted by default, volume 0 where the
  // browser allows it (iOS ignores volume; muted is what counts there), and
  // forced back on any change.
  function lockMute(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    try { video.volume = 0; } catch (e) { /* read-only on iOS */ }
    video.addEventListener('volumechange', function () {
      if (!video.muted || video.volume > 0) {
        video.muted = true;
        try { video.volume = 0; } catch (e) { /* read-only on iOS */ }
      }
    });
  }

  var ICONS = '<svg class="cc-video__icon-pause" aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M6 4h4v16H6zM14 4h4v16h-4z"/></svg>' +
    '<svg class="cc-video__icon-play" aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M7 4.5v15l12.5-7.5z"/></svg>';

  // The tap player's only control: play/pause. Tapping the video does the same.
  function addTapToggle(root, video) {
    var t = document.createElement('button');
    t.type = 'button';
    t.className = 'cc-video__toggle cc-video__toggle--tap';
    t.innerHTML = ICONS;
    function render() {
      var playing = !video.paused && !video.ended;
      t.classList.toggle('is-paused', !playing);
      t.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }
    function flip(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      // A shopper's own pause sticks: autoplay won't restart this video until
      // they press play again.
      if (video.paused) { root.ccUserPaused = false; safePlay(video); }
      else { root.ccUserPaused = true; video.pause(); }
    }
    t.addEventListener('click', flip);
    video.addEventListener('click', flip);
    video.addEventListener('play', render);
    video.addEventListener('pause', render);
    render();
    root.appendChild(t);
  }

  // ---- tap (PDP gallery) ----------------------------------------------------

  var tapVideos = [];
  var autoplayAllowed = !reducedMotion.matches && !saveData;
  var autoplayBlocked = false;   // set once the browser refuses (Low Power Mode)
  var AUTO_IN = 0.6;             // autoplay the most visible video above this
  var PAUSE_BELOW = 0.25;        // pause any video below this
  var ratios = new Map();        // gallery root -> current visible ratio

  function pauseOtherTaps(except) {
    tapVideos.forEach(function (v) { if (v !== except && !v.paused) v.pause(); });
  }

  function videoOf(root) { return root.querySelector('video.cc-video__el'); }

  // One decision for every gallery video after any visibility change.
  function evaluate() {
    var best = null;
    var bestRatio = 0;
    var someoneWatching = false;
    ratios.forEach(function (ratio, root) {
      var v = videoOf(root);
      if (v && !v.paused && ratio < PAUSE_BELOW) v.pause();
      if (v && !v.paused && ratio >= PAUSE_BELOW) someoneWatching = true;
      if (root.ccAuto && ratio >= AUTO_IN && !root.ccUserPaused && ratio > bestRatio) {
        best = root;
        bestRatio = ratio;
      }
    });
    // Never take over from a video that is already playing on screen (the
    // shopper may have started it themselves).
    if (best && !someoneWatching && autoplayAllowed && !autoplayBlocked) best.ccStart(null, true);
  }

  var tapObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { ratios.set(e.target, e.isIntersecting ? e.intersectionRatio : 0); });
        evaluate();
      }, { threshold: [0, 0.1, PAUSE_BELOW, 0.4, 0.5, AUTO_IN, 0.75, 0.9, 1] })
    : null;

  function initTap(root) {
    var button = root.querySelector('[data-cc-video-play]');
    var template = root.querySelector('template[data-cc-video-template]');
    if (!button || !template) return;
    var first = template.content.firstElementChild;
    // Shopify-hosted <video> autoplays; YouTube/Vimeo iframes stay tap-to-play.
    root.ccAuto = !!(first && first.tagName === 'VIDEO');

    function start(e, auto) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      if (!auto) root.ccUserPaused = false;
      var el = videoOf(root) || root.querySelector('.cc-video__el');
      if (!el) {
        el = template.content.firstElementChild.cloneNode(true);
        root.appendChild(el);
        if (el.tagName === 'VIDEO') {
          lockMute(el);
          addTapToggle(root, el);
          tapVideos.push(el);
          el.addEventListener('playing', function () {
            root.classList.add('is-playing');
            root.classList.remove('is-autoplay-blocked');
            pauseOtherTaps(el);
          });
        } else {
          root.classList.add('is-playing');
        }
      }
      if (el.tagName !== 'VIDEO') { root.classList.add('is-loaded'); return; }
      if (!el.paused) return;
      root.classList.add('is-loaded');
      safePlay(el, function () {
        if (auto) {
          // Autoplay refused (iOS Low Power Mode and similar): stop trying on
          // this page and put the poster's play button back.
          autoplayBlocked = true;
          root.classList.remove('is-loaded');
          root.classList.add('is-autoplay-blocked');
        } else {
          root.classList.add('is-playing');
        }
      });
    }

    root.ccStart = start;
    button.addEventListener('click', start);
    if (tapObserver) tapObserver.observe(root);
  }

  // ---- ambient (hero / banner) ----------------------------------------------

  function initAmbient(root) {
    var video = root.querySelector('video.cc-video__el');
    if (!video) return;
    lockMute(video);

    var mqText = root.getAttribute('data-cc-video-media');
    var mq = mqText ? window.matchMedia(mqText) : null;
    var userPaused = reducedMotion.matches || saveData;
    var inView = false;

    function active() { return !mq || mq.matches; }

    function play() {
      if (!active()) return;
      attachSources(video);
      safePlay(video, function () { setState(false); });
    }

    function maybePlay() {
      if (!userPaused && inView && active() && document.visibilityState !== 'hidden') play();
    }

    function setState(playing) {
      root.classList.toggle('is-playing', playing);
      toggles().forEach(function (t) { renderToggle(t); });
    }

    root.ccVideo = {
      active: active,
      playing: function () { return !video.paused && !video.ended; },
      toggle: function () {
        if (video.paused) { userPaused = false; play(); }
        else { userPaused = true; video.pause(); }
      }
    };

    function toggles() {
      var list = Array.prototype.slice.call(root.querySelectorAll('[data-cc-video-toggle]'));
      if (root.id) {
        document.querySelectorAll('[data-cc-video-for]').forEach(function (t) {
          if ((' ' + t.getAttribute('data-cc-video-for') + ' ').indexOf(' ' + root.id + ' ') !== -1) list.push(t);
        });
      }
      return list;
    }

    video.addEventListener('playing', function () { setState(true); });
    video.addEventListener('pause', function () { setState(false); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inView = e.isIntersecting;
          if (inView) maybePlay();
          else if (!video.paused) video.pause();
        });
      }, { rootMargin: '200px 0px' }).observe(root);
    } else {
      inView = true;
      maybePlay();
    }

    if (mq) {
      var onChange = function () { if (active()) maybePlay(); else video.pause(); };
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') video.pause();
      else maybePlay();
    });

    setState(false);
  }

  // A toggle may control several wrappers (hero desktop + mobile pair). It acts
  // on whichever of them is active at the current width.
  function targetsOf(toggle) {
    var ids = toggle.getAttribute('data-cc-video-for');
    var roots = ids
      ? ids.split(/\s+/).map(function (id) { return document.getElementById(id); })
      : [toggle.closest('[data-cc-video="ambient"]')];
    return roots.filter(function (r) { return r && r.ccVideo && r.ccVideo.active(); });
  }

  function renderToggle(toggle) {
    var playing = targetsOf(toggle).some(function (r) { return r.ccVideo.playing(); });
    toggle.classList.toggle('is-paused', !playing);
    toggle.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video');
  }

  function initToggle(toggle) {
    toggle.hidden = false;
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      targetsOf(toggle).forEach(function (r) { r.ccVideo.toggle(); });
    });
    renderToggle(toggle);
  }

  // ---- boot -------------------------------------------------------------------

  function init(scope) {
    (scope || document).querySelectorAll('[data-cc-video]:not([data-cc-video-ready])').forEach(function (root) {
      root.setAttribute('data-cc-video-ready', '');
      if (root.getAttribute('data-cc-video') === 'ambient') initAmbient(root);
      else initTap(root);
    });
    (scope || document).querySelectorAll('[data-cc-video-toggle]:not([data-cc-video-ready])').forEach(function (t) {
      t.setAttribute('data-cc-video-ready', '');
      initToggle(t);
    });
  }

  window.ccVideo = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Theme editor: sections re-render in place.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
